<div class="chat-composer">
  <div class="chat-composer__field">
    <ion-textarea
      class="chat-composer__input"
      [placeholder]="placeholder()"
      [value]="draft()"
      [autoGrow]="true"
      [rows]="1"
      (ionInput)="onInput($event)" />

    @if (streaming()) {
      <c-button
        size="small"
        [iconOnly]="true"
        [icon]="stopIcon"
        [ariaLabel]="'chatbot.stop' | transloco"
        (action)="onStop()" />
    } @else {
      <c-button
        size="small"
        [iconOnly]="true"
        [icon]="sendIcon"
        [ariaLabel]="'chatbot.send' | transloco"
        [disabled]="!canSend()"
        (action)="onSend()" />
    }
  </div>
</div>
